/*
 * @Author: Ashley.Liu
 * @Date: 2022-06-28 13:38:30
 * @LastEditTime: 2022-08-09 10:06:56
 * @Description: desc
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/Layout'
import search from './search'
import esms from './esms'

Vue.use(VueRouter)

let routes = [
  {
    path: '/',
    redirect: '/login',
    component: Layout
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/loading.vue')
  },
  {
    path: '/401',
    name: '401',
    component: () => import('../views/errors/401'),
    meta: { title: '401' }
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/errors/404'),
    meta: { title: '404' }
  },
  {
    path: '*',
    redirect: '/404'
  }
]
routes = [...routes, ...search, ...esms]

const router = new VueRouter({
  routes
})

export default router
export { routes }
